import { render, staticRenderFns } from "./petitem.vue?vue&type=template&id=7378b256&"
import script from "./petitem.vue?vue&type=script&lang=js&"
export * from "./petitem.vue?vue&type=script&lang=js&"
import style1 from "../item/item.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports